<div class="container mt-6 w-full px-4 sm:px-8 lg:px-16">
  <h1
    class="mt-20 mb-2 bg-clip-text text-5xl leading-tight text-transparent lg:text-8xl"
    style="
      background: linear-gradient(
        to right,
        #008b79 0%,
        #008c6c 27%,
        #169999 60%,
        #004365 100%
      );
      background-clip: text;
    "
  >
    {{ 'pages.newWebsite.title' | translate }}
  </h1>
  <div class="mb-10 text-lg leading-normal font-normal text-secondary-text">
    {{ 'pages.newWebsite.subtitle' | translate }}
  </div>
  <div class="mb-16 flex flex-col gap-8 text-primary-text">
    @for (section of content; track section.title) {
      <div class="flex flex-col gap-2">
        <h2 class="text-2xl font-semibold">{{ section.title | translate }}</h2>
        <p class="text-base" [innerHTML]="section.content | translate"></p>
      </div>
    }
  </div>
</div>
